import { render, staticRenderFns } from "./b2b-download.vue?vue&type=template&id=5c0ecbda"
import script from "./b2b-download.vue?vue&type=script&lang=js"
export * from "./b2b-download.vue?vue&type=script&lang=js"
import style0 from "./b2b-download.vue?vue&type=style&index=0&id=5c0ecbda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports